export enum MatrizEstado {
  Borrador,
  Verificada,
  NoVerificada,
  Discontinuada,
  Averiada,
  EnReparacion,
}

export const MatrizEstadoLabels: { [key in MatrizEstado]: string } = {
  [MatrizEstado.Borrador]: 'Borrador',
  [MatrizEstado.Verificada]: 'Verificada',
  [MatrizEstado.NoVerificada]: 'No Verificada',
  [MatrizEstado.Discontinuada]: 'Discontinuada',
  [MatrizEstado.Averiada]: 'Averiada',
  [MatrizEstado.EnReparacion]: 'En Reparación',
};

export const getMatrizEstado = () => {
  return Object.values(MatrizEstado)
    .filter((value) => typeof value === 'number')
    .map((id) => ({
      id,
      text: MatrizEstadoLabels[id as MatrizEstado],
    }));
};

export const colorMapping: { [key in MatrizEstado]: string } = {
  [MatrizEstado.Borrador]: '#70BDFF',
  [MatrizEstado.Verificada]: '#22c55e',
  [MatrizEstado.NoVerificada]: '#FF0000',
  [MatrizEstado.Discontinuada]: 'black',
  [MatrizEstado.Averiada]: '#FF0000',
  [MatrizEstado.EnReparacion]: 'orange',
};
